// @flow
import styled from 'styled-components';
import colors from "../../assets/css/colors";

export const SearchSubmitButton = styled.button`
	position: absolute;
	top: 0;
	right: 0;
	outline: none;
	border: none;
	background: ${colors.nrlDarkGreen};
	color: ${colors.nrlGreen};
	height: 36px;
	width: 36px;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0 5px 5px 0;
`;

export default SearchSubmitButton;


// WEBPACK FOOTER //
// ./src/components/SearchSubmitButton/index.js